import { useState } from 'react';
import useSWR from 'swr';
import Button from '../../../Button';
import Modal from '../../../Modal';
import SkeletonComponent from '../../../SkeletonComponent';

export default function ExemptionCardStatus({ memberId }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const { data: exemption, mutate: revalidateExemption } = useSWR(
    memberId ? `/admin/${memberId}/payment-exemption` : null
  );

  const { data: liveEfrikort, isLoading: isFetchingLive } = useSWR(dialogOpen ? `/admin/${memberId}/efrikort` : null);

  const closeDialog = () => {
    setDialogOpen(false);
    revalidateExemption();
  };

  const modal = (
    <Modal
      header="Frikortsstatus"
      actionI18nKey="global.buttons.ok"
      visible={dialogOpen}
      onClose={closeDialog}
      onActionCompleted={closeDialog}
      actionCompletable={true}
      size="small"
    >
      {isFetchingLive ? (
        <SkeletonComponent height="30px" />
      ) : liveEfrikort ? (
        <>
          {liveEfrikort.status === 'PRELIMINARY' || liveEfrikort.status === 'FINAL' ? (
            <p>Patienten har sedan uppnått eFrikort sedan senaste koll.</p>
          ) : null}
          <p>
            <strong>{liveEfrikort.currentAmount ?? 0} av 1450 kr.</strong>
          </p>
          <p>Beloppet baseras på avgifter för öppenvård de senaste 12 månaderna.</p>
        </>
      ) : (
        <p>Patienten har inget eFrikort</p>
      )}
    </Modal>
  );

  // Manual exemption card
  if (exemption?.source === 'EXEMPTION_CARD') {
    return <div>Frikort till {exemption.endDate}</div>;
  }

  // Efrikort PRELIMINARY or FINAL
  if (exemption?.source === 'EFRIKORT' && (exemption.status === 'PRELIMINARY' || exemption.status === 'FINAL')) {
    return <div>eFrikort till {exemption.endDate}</div>;
  }

  // Efrikort NOT_CONNECTED
  if (exemption?.source === 'EFRIKORT' && exemption.status === 'NOT_CONNECTED') {
    return <div>eFrikort: Ej ansluten</div>;
  }

  // No cached data at all
  if (!exemption) {
    return (
      <>
        <div>
          Frikortsinfo saknas.{' '}
          <Button buttonType="text" onClick={() => setDialogOpen(true)}>
            Hämta info
          </Button>
        </div>
        {modal}
      </>
    );
  }

  // BELOW_LIMIT or other efrikort statuses
  return (
    <>
      <div>
        Inget frikort.{' '}
        <Button buttonType="text" onClick={() => setDialogOpen(true)}>
          Visa belopp
        </Button>
      </div>
      {modal}
    </>
  );
}
